import { render, staticRenderFns } from "./ahTip.vue?vue&type=template&id=0d50ee19&"
import script from "./ahTip.vue?vue&type=script&lang=js&"
export * from "./ahTip.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports